////import { HttpClient, HttpHeaders } from '@angular/common/http';
////import { Observable } from 'rxjs';
////import { ConfigurationService } from '../../../Configuration/configuration.service';
import { LocalStorageService } from '../../../Shared/common/local-storage.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../Configuration/configuration.service';
  const opts: any = {
    headers: new HttpHeaders({
      'Accept': 'text/html, application/xhtml+xml,application/json, */*',
      'Content-Type': 'text/plain; charset=utf-8, application/json'
    }),
  responseType: 'text'
};
@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  
  private apiUrl = this.configService.getAPIBaseUrl();

  constructor(private http: HttpClient, private configService: ConfigurationService, private dataShareService: CharityDataShareServiceService, private lsService: LocalStorageService) { }

  CharityListReports(CentralUserId: any): Observable<any> {
    debugger
    CentralUserId = +CentralUserId;
    const url = `${this.apiUrl}/Reports/CharityListReports?CentralUserId=`;
    return this.http.post(url + CentralUserId, opts);

  }
  GetFilterCharityGrid(Type?: any, Jurisdiction?: any, Trading_Status?: any, UserId?: any, Buttontype?: any,): Observable<any> {
    debugger
    UserId = +UserId;
    const url = `${this.apiUrl}/Reports/FilterCharityListReports?Charitytype=${Type}&Jurisdiction=${Jurisdiction}&Trading_Status=${Trading_Status}&UserId=${UserId}&Buttontype=${Buttontype}`;
    return this.http.post(url, opts);

  }
  
  Gettrusteelist(charityId: any, Ischair: any, selectedCharityName: any, Buttontype: any, FinancialID:any): Observable<any> {
    debugger
    let encodedCharityName = encodeURIComponent(selectedCharityName); //Encode special characters #, &, ? etc
    const url = `${this.apiUrl}/Reports/Gettrusteelist?charityId=${charityId}&Ischair=${Ischair}&selectedCharityName=${encodedCharityName}&Buttontype=${Buttontype}&FinancialID=${FinancialID}`;
    return this.http.post(url, opts);
  }
  GetTrailBalance(PeriodId: any, UserId: any, centralUserId: any, charityId: any, IsFirstAcctPeriod: any, IsFundTrack: any, flag: any,) {
    centralUserId = +centralUserId;
    const url = `${this.apiUrl}/Reports/GetTrialBalance?PeriodId=${PeriodId}&UserId=${UserId}&centralUserId=${centralUserId}&charityId=${charityId}&IsFirstAcctPeriod=${IsFirstAcctPeriod}&IsFundTrack=${IsFundTrack}&flagForPrint=${flag}`;
    return this.http.post(url, opts);
  }
  GetcharOfAccount(PeriodId: any, UserId: any, centralUserId: any, charityId: any, IsFirstAcctPeriod: any, IsFundTrack: any, flag: any,) {
    centralUserId = +centralUserId;
    const url = `${this.apiUrl}/Reports/GetcharOfAccount?PeriodId=${PeriodId}&UserId=${UserId}&centralUserId=${centralUserId}&charityId=${charityId}&IsFirstAcctPeriod=${IsFirstAcctPeriod}&IsFundTrack=${IsFundTrack}&flagForPrint=${flag}`;
    return this.http.post(url, opts);
  }
  Receipts_PaymentsReport(PeriodId: any, IsFirstAcctPeriod: any, IsFundTrack: any) {
    const url = `${this.apiUrl}/Reports/ReceiptsPaymentsReport?PeriodId=${PeriodId}&IsFirstAcctPeriod=${IsFirstAcctPeriod}&IsFundTrack=${IsFundTrack}`;
    return this.http.post(url, opts);
  }
  Statement_of_Assets_liabilities_Reports(PeriodId: any, IsFirstAcctPeriod: any, IsFundTrack: any) {
    const url = `${this.apiUrl}/Reports/StatementofAssetsliabilitiesReports?PeriodId=${PeriodId}&IsFirstAcctPeriod=${IsFirstAcctPeriod}&IsFundTrack=${IsFundTrack}`;
    return this.http.post(url, opts);
  }
  GetSOFA(PeriodID: any, UserId: any, centralUserId: any, charityId: any, IsFundTrack: any) {
    centralUserId = +centralUserId;
    const url = `${this.apiUrl}/Reports/GetSOFA?PeriodID=${PeriodID}&UserId=${UserId}&centralUserId=${centralUserId}&charityId=${charityId}&IsFundTrack=${IsFundTrack}`;
    return this.http.post(url, opts);
  }
  GetBalanceSheet(PeriodID: any, UserId: any, centralUserId: any, charityId: any, IsFundTrack: any) {
    centralUserId = +centralUserId;
    const url = `${this.apiUrl}/Reports/GetBalanceSheet?PeriodID=${PeriodID}&UserId=${UserId}&centralUserId=${centralUserId}&charityId=${charityId}&IsFundTrack=${IsFundTrack}`;
    return this.http.post(url, opts);
  }
}
 
  


